import {
  GET_WIC_AGENCIES,
  DELETE_WIC_AGENCY,
  ERROR_DATA,
  SAVE_WIC_AGENCY,
  UPDATE_WIC_AGENCY,
  SYNCING,
  GET_WIC_AGENCY,
  RESET_WIC_AGENCY,
  LOAD_WIC_AGENCIES,
  LOAD_WIC_AGENCY,
  RESET_WIC_AGENCIES
} from './actionTypes';
import {
  IDeleteWicAgencyAction,
  ISetWicAgencyAction,
  ISetWicAgencyErrorAction,
  IWicAgencyAction,
  IWicAgencyItem,
  IWicAgenciesState,
  ISetWicAgenciesAction,
} from './types';

export const initialState: IWicAgenciesState = {
  error: null,
  wicAgencies: [],
  wicAgenciesLoaded: false,
  wicAgencyLoaded: false,
  syncing: false,
  wicAgency: null,
};

export const reducer = (
  state: IWicAgenciesState = initialState,
  action: IWicAgencyAction
): IWicAgenciesState => {
  let wicAgencies: IWicAgencyItem[] = [];
  switch (action.type) {
    case LOAD_WIC_AGENCIES:
      return { ...state, syncing: true };
    case GET_WIC_AGENCIES:
      return {
        ...state,
        error: null,
        syncing: false,
        wicAgenciesLoaded: true,
        wicAgencies: (action as ISetWicAgenciesAction).payload,
      };
    case ERROR_DATA:
      return {
        ...state,
        error: (action as ISetWicAgencyErrorAction).payload,
        syncing: false,
      };
    case DELETE_WIC_AGENCY:
      wicAgencies = state.wicAgencies.filter(
        (item) => item.stateIdentifierCode !== (action as IDeleteWicAgencyAction).payload
      );
      return { ...state, error: null, wicAgencies };
    case UPDATE_WIC_AGENCY:
      const act = action as ISetWicAgencyAction;
      const wicAgencyId = act.payload.stateIdentifierCode;
      const updatedWicAgencies = state.wicAgencies.map((item) => {
        if (item.stateIdentifierCode === wicAgencyId) {
          return act.payload;
        }
        return item;
      });
      return {
        ...state,
        error: null,
        wicAgencies: updatedWicAgencies,
        syncing: false,
        wicAgency: act.payload,
      };
    case SAVE_WIC_AGENCY:
      const newWicAgencies = state.wicAgencies.filter(() => true);
      newWicAgencies.push((action as ISetWicAgencyAction).payload);
      return { ...state, error: null, wicAgencies: newWicAgencies, syncing: false };
    case LOAD_WIC_AGENCY:
      return { ...state, syncing: true };
    case GET_WIC_AGENCY:
      return {
        ...state,
        syncing: false,
        wicAgency: (action as ISetWicAgencyAction).payload,
      };
    case RESET_WIC_AGENCIES:
      return { ...initialState };
    case RESET_WIC_AGENCY:
      return {
        ...state,
        wicAgency: null
      };
    case SYNCING:
      return { ...state, syncing: true };

    default:
      return state;
  }
};
